import React from "react";
import { CreateMedication, MedicationGroup } from "components";
import { useAuth, useParams } from "duck";
import {
  MedicationCalculationTypeEnum,
  useGetAnestheticProtocolQuery,
  UserRoleEnum
} from "requests";
import {
  useCreateAnestheticProtocolMedicationCalculation,
  useDeleteMedications,
  useUpdateAnestheticProtocolMedicationCalculation
} from "./duck";

const Medications: React.FC = () => {
  const { id: anestheticProtocolId } = useParams();
  const { data: protocol } = useGetAnestheticProtocolQuery({
    variables: { _id: +anestheticProtocolId }
  });
  const [{ user }] = useAuth();

  const preAnestheticMedications =
    protocol?.anestheticProtocol?.medicationCalculations?.collection.filter(
      medication =>
        medication.type === MedicationCalculationTypeEnum.PreAnesthetic
    ) || [];
  const inductionMedications =
    protocol?.anestheticProtocol?.medicationCalculations?.collection.filter(
      medication => medication.type === MedicationCalculationTypeEnum.Induction
    ) || [];
  const additionalMedications =
    protocol?.anestheticProtocol?.medicationCalculations?.collection.filter(
      medication => medication.type === MedicationCalculationTypeEnum.Additional
    ) || [];

  const deleteMedications = useDeleteMedications();
  const create = useCreateAnestheticProtocolMedicationCalculation();
  const updateMedication = useUpdateAnestheticProtocolMedicationCalculation();

  const defaultProtocol =
    protocol?.anestheticProtocol?.defaultProtocol &&
    user.userRole !== UserRoleEnum.RoleOrganizationAdmin;

  if (!protocol?.anestheticProtocol) {
    return null;
  }

  return (
    <MedicationGroup.Provider update={updateMedication}>
      <MedicationGroup
        groupName="Pre-Anesthetic Medications"
        medications={preAnestheticMedications}
        medicationType={MedicationCalculationTypeEnum.PreAnesthetic}
        create={
          !defaultProtocol ? (
            <CreateMedication
              calculationType={MedicationCalculationTypeEnum.PreAnesthetic}
              successToast="Pre-Anesthetic Medication is created successfully."
              onSubmit={values =>
                create(values, MedicationCalculationTypeEnum.PreAnesthetic)
              }
              isProtocol
            />
          ) : (
            undefined
          )
        }
        onDelete={!defaultProtocol ? deleteMedications : undefined}
        expandedCards={false}
        hasTimeAdministered={false}
        viewOnly={defaultProtocol}
      />

      <MedicationGroup
        groupName="Induction Medications"
        medications={inductionMedications}
        medicationType={MedicationCalculationTypeEnum.Induction}
        create={
          !defaultProtocol ? (
            <CreateMedication
              calculationType={MedicationCalculationTypeEnum.Induction}
              successToast="Induction Medication is created successfully."
              onSubmit={values =>
                create(values, MedicationCalculationTypeEnum.Induction)
              }
              isProtocol
            />
          ) : (
            undefined
          )
        }
        onDelete={!defaultProtocol ? deleteMedications : undefined}
        expandedCards={false}
        hasTimeAdministered={false}
        hasAdditionalVolumeToBeDrawn={false}
        viewOnly={defaultProtocol}
      />

      <MedicationGroup
        groupName="Additional Medications"
        medications={additionalMedications}
        medicationType={MedicationCalculationTypeEnum.Additional}
        create={
          !defaultProtocol ? (
            <CreateMedication
              calculationType={MedicationCalculationTypeEnum.Additional}
              successToast="Additional Medication is created successfully."
              onSubmit={values =>
                create(values, MedicationCalculationTypeEnum.Additional)
              }
              isProtocol
            />
          ) : (
            undefined
          )
        }
        onDelete={!defaultProtocol ? deleteMedications : undefined}
        expandedCards={false}
        hasTimeAdministered={false}
        viewOnly={defaultProtocol}
      />
    </MedicationGroup.Provider>
  );
};

export default Medications;
